module.exports = __webpack_public_path__ + "static/media/homepage.694d8b3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/views/Help/assets/homepage.png
// module id = 1866
// module chunks = 193